import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "@NP-Webber/crm-kit/dist/theme/crmGlobals.css";
import "@NP-Webber/crm-kit/dist/formkit/FormKit.css";
import "@NP-Webber/crm-kit/dist/tablekit/TableKit.css";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
